// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","ToolbarText":"Footer_ToolbarText__1VO7L"};